var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("缺少登录信息"+_vm._s(_vm.error ? ":" + _vm.error : ""))])
}
var staticRenderFns = []

export { render, staticRenderFns }